export const SITE_USER_SUBSCRIPTION_BINDING_CONTEXT_ID =
  'site-user-subscription';
export const SITE_USER_SUBSCRIPTION_BINDING_CONTEXT_TYPE_ID =
  'site-user-subscription-type';

export const SITE_USER_ACCOUNT_PAGE_BINDING_CONTEXT_ID =
  'site-user-account-page';
export const SITE_USER_ACCOUNT_PAGE_TYPE_ID = 'site-user-account-page-type';
